import React, {Dispatch, SetStateAction} from 'react'
import {useIntl} from 'react-intl'
import {Stack, HStack, Box, Text, useMultiStyleConfig, StackProps, TextProps} from '@chakra-ui/react'
import {Icon} from '_uiComponents'
import {useViewport, useAnalytics} from '_customHooks'
type ListingType = 'grid3' | 'grid2'

interface GridLayoutControlsProps {
    listingLayout: ListingType
    setListingLayout: Dispatch<SetStateAction<ListingType>> | ((layout: ListingType) => void)
}

const GridLayoutControls = ({listingLayout, setListingLayout}: GridLayoutControlsProps) => {
    const {formatMessage} = useIntl()
    const styles = useMultiStyleConfig('GridLayoutControls') as Record<string, StackProps | TextProps>
    const {isMobile} = useViewport()

    const grid2Label = formatMessage({id: 'template.accessibility.grid2', defaultMessage: 'View in Grid 2 mode'})
    const grid3Label = formatMessage({id: 'template.accessibility.grid3', defaultMessage: 'View in Grid 3 mode'})
    const wallLabel = formatMessage({id: 'template.accessibility.wall', defaultMessage: 'View in Wall mode'})

    const {analyticsDynamicPage} = useAnalytics()

    const handleListingLayout = (layout: ListingType) => {
        ;(document.querySelector('.openedSizeSelector') as HTMLElement)?.click()
        analyticsDynamicPage({listingType: layout})
        setListingLayout(layout)
    }

    return (
        <HStack {...styles.wrapper} data-testid="grid-layout-controls">
            <Stack {...styles.gridWrapper}>
                <Text>{formatMessage({id: 'label.plp.template.grid', defaultMessage: 'GRID'})}</Text>
                <Box
                    as="button"
                    {...styles.icon}
                    data-testid="filter-icon-grid3"
                    onClick={() => handleListingLayout('grid3')}
                    onKeyDown={(e) => e.key === 'Enter' && handleListingLayout('grid3')}
                    aria-label={isMobile ? grid2Label : grid3Label}
                    aria-pressed={listingLayout === 'grid3'}
                >
                    <Icon name={isMobile ? 'IconGrid2' : 'IconGrid3'} size={isMobile ? 'sm' : 'md'} isFilled={listingLayout === 'grid3'} />
                </Box>
            </Stack>
            <Stack {...styles.gridWrapper}>
                {isMobile && <Text>{formatMessage({id: 'label.plp.template.wall', defaultMessage: 'Wall'})}</Text>}
                <Box
                    as="button"
                    {...styles.icon}
                    data-testid="filter-icon-grid2"
                    onClick={() => handleListingLayout('grid2')}
                    onKeyDown={(e) => e.key === 'Enter' && handleListingLayout('grid2')}
                    aria-label={isMobile ? wallLabel : grid2Label}
                    aria-pressed={listingLayout === 'grid2'}
                >
                    <Icon name={isMobile ? 'IconGridWall' : 'IconGrid2'} size={isMobile ? 'sm' : 'md'} isFilled={listingLayout === 'grid2'} />
                </Box>
            </Stack>
        </HStack>
    )
}

export {GridLayoutControls}
